import { Dropdown, DropdownButton } from "@similarweb/ui-components";
import { DropdownContainer } from "../../styles";
import type { ReactElement } from "react";
import { useCallback, useMemo } from "react";
import GroupItem from "./GroupItem";
import type { ICustomSegmentsGroup } from "app/services/segments/segmentsApiService";
import { translate } from "app/filters/i18nFilter";
import { DROPDOWN_GROUPS_HEIGTH } from "../../constants";

type SegmentGroupsDropdownProps = {
    selectedGroupId: string;
    segmentsGroups: ICustomSegmentsGroup[];
    setSelectedGroupId: (id: string) => void;
};
const SegmentGroupsDropdown = ({ selectedGroupId, segmentsGroups, setSelectedGroupId }: SegmentGroupsDropdownProps) => {
    const selectedSegmentGroupItem = useMemo(
        () => segmentsGroups?.find((group) => group.id === selectedGroupId),
        [selectedGroupId, segmentsGroups],
    );

    const handleSearch = useCallback(
        (searchText: string, item: ReactElement<{ group: ICustomSegmentsGroup }>): boolean =>
            item.props.group.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1,
        [],
    );

    const groupsToRender = useMemo(
        () =>
            segmentsGroups
                ? [
                      ...segmentsGroups?.map((group) => (
                          <GroupItem
                              key={group.id}
                              group={group}
                              hasWebsites={!!group?.websites?.length}
                          />
                      )),
                  ]
                : [],
        [segmentsGroups],
    );

    const getHeaderComponent = () =>
        selectedGroupId && selectedSegmentGroupItem ? (
            <DropdownButton>
                <GroupItem
                    key={selectedGroupId}
                    group={selectedSegmentGroupItem}
                    isSelectedInInput
                    hasWebsites={!!selectedSegmentGroupItem?.websites.length}
                />
            </DropdownButton>
        ) : (
            <DropdownButton>{translate("wizard.segments.group.search.graph")}</DropdownButton>
        );

    return (
        <DropdownContainer>
            <Dropdown
                selectedIds={{ [selectedGroupId]: true }}
                onClick={({ group }) => !group.isDisabled && setSelectedGroupId(group.id)}
                hasSearch
                searchFilter={handleSearch}
                disabled={!segmentsGroups}
                dropdownPopupHeight={DROPDOWN_GROUPS_HEIGTH}
                searchPlaceHolder={translate("wizard.segments.group.search.placeholder.website.segments")}
            >
                {[getHeaderComponent(), ...groupsToRender]}
            </Dropdown>
        </DropdownContainer>
    );
};
export default SegmentGroupsDropdown;
